// extracted by mini-css-extract-plugin
module.exports = {"externalContainer":"styles_externalContainer__1qPVN","title":"styles_title__1JWll"};